import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";

import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import CreditCard from "../CreditCard";

import { 
    TitleAndStatusContainer, 
    Title, 
    StatusContainer, 
    Date, 
    Close, 
    Row, 
    AlertContainer, 
    ErrorTitle, 
    ErrorDescription, 
    Jumbotron, 
    JumbotronTitle, 
    CreditCardContainer, 
    InfoTitle, 
    Info,
    ButtonsContainer,
    ButtonDownloadContainer,
    ButtonDownload,
    ButtonsShareContainer,
    ButtonShare,
    ButtonShareText,
    SendMessageTitle
} from "./styles";

//Interfaces
import { ModalDetailsPropsInterface } from "./interfaces";

import { translateStatus } from "../../utils/translate/status"

//Assets
import colors from "../../assets/css/colors";
import close from "../../assets/icons/close.svg";
import errorIcon from "../../assets/icons/error.svg";
import whatsapp from "../../assets/icons/whatsapp.svg";
import mail from "../../assets/icons/mailRed.svg";
import { translatePaymentType } from "../../utils/translate/paymentType";
import { translateMessageError } from "../../utils/translate/messageErrors";

const ModalDetails = (props: ModalDetailsPropsInterface) => { 
    const login = useSelector((state: any) => state.login);
    const branchs = useSelector ((state: any) => state.branchs);

    const statusContainerBackgroundDefiner = (status: string) => { 
        const objStatus = {
            succeeded: colors.greenDark,
            failed: colors.redDark
        }

        return objStatus[status as keyof typeof objStatus]
            ?? colors.gray
    }

    const getTransactionDate = () => {
        const date = moment(props.data.tr_created_at).add(3, "hours").format("DD/MM/YYYY");
        
        return date;
    }

    const getTransactionDateWithTime = () => {
        const dateWithTime = moment(props.data.tr_updated_at).format("DD/MM/YYYY HH:mm");
        
        return dateWithTime;
    }

    const getSellerData = () => {
        if(login.user.branchsId){
            return {
                businessName: login.user.branchs.businessName,
                cnpj: login.user.branchs.taxpayerIdBranch,
                email: login.user.branchs.businessEmail,
                phone: login.user.branchs.businessPhone
            }
        }
        
        else {
            const branch = branchs.branchs.filter((isThisBranch: any) => isThisBranch.sellerOwnerPayId === props.data.tr_sellerOwnerPayId);
            
            if(branch[0] !== undefined){
                return {
                    businessName: branch[0].businessDescription,
                    cnpj: branch[0].taxpayerIdBranch,
                    email: branch[0].businessEmail,
                    phone: branch[0].businessPhone
                }
            } else {
                return {
                    businessName: "",
                    cnpj: "",
                    email: "",
                    phone: ""
                }
            }
        }
    }

    const getBuyerData = () => {
        if(props.data.tr_buyerIdAdquirente !== null){
            return{
                name: `${props.data.bu_firstName} ${props.data.bu_lastName}` == "undefined undefined"? 
                `${props.data.firstName} ${props.data.lastName}`:
                `${props.data.bu_firstName} ${props.data.bu_lastName}` 
                    ,
                document: props.data.bu_taxpayerId,
                phone: props.data.phoneNumber,
            }
        } else {
            return{
                name: "Não especificado",
                document: "Não especificado",
                phone: "Não especificado",
            }
        }
    }

    const downloadIMGOnClick = () => {
        const input = document.getElementById("comprovante");

        html2canvas(input as HTMLElement, {}).then((canvas) => {
            const a = document.createElement("a");
            
            a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
            a.download = props.data.tr_buyerIdAdquirente === null ? `tr_${props.data.mt_holderName}.jpg` : `tr_${props.data.firstName} ${props.data.lastName}`;
            a.click();
        });
    }

    const downloadPDFOnClick = () => {
        const input = document.getElementById("comprovante");

        html2canvas(input as HTMLElement)
            .then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF({});
                const imgProps= pdf.getImageProperties(imgData);
                const pdfWidth = (pdf.internal.pageSize.getWidth()) * 0.5;
                const pdfHeight = ((imgProps.height * pdfWidth) / imgProps.width);
                
                pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                pdf.save(props.data.tr_buyerIdAdquirente === null ? `tr_${props.data.mt_holderName}.pdf` : `tr_${props.data.firstName} ${props.data.lastName}.pdf`);
            });
    }

    const seller = getSellerData();
    const buyer = getBuyerData();

    const messageError = () => {
        if(translatePaymentType(props.data.tr_paymentType) === "Pix" && translateMessageError(props.data.ht_responseCode) === null) {
            return "Tempo expirado";
        } 
        
        else if (translateMessageError(props.data.ht_responseCode) === null ){
            return props.data.ht_responseMessage
        }

        else {
            return translateMessageError(props.data.ht_responseCode)
        }
    }

    return (        
        <div className="modal fade" id={props.id}  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-details">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between mb-0 pb-0">
                        <div>
                            <TitleAndStatusContainer>
                                <Title>Detalhes da venda</Title>
                                <StatusContainer color={statusContainerBackgroundDefiner(props.data.tr_status)}>{translateStatus(props.data.tr_status)}</StatusContainer>
                            </TitleAndStatusContainer>
                            <Date>{getTransactionDateWithTime()}</Date>
                        </div>
                        <Close data-dismiss="modal" aria-label="Close">
                            <img src={close} alt="fechar"/>
                        </Close>
                    </div>
                    <div className="modal-body pb-0" id="comprovante">
                        {
                            props.data.tr_status !== "succeeded" ? (
                                <Row>
                                    <AlertContainer>
                                        <img src={errorIcon} alt="alerta"/>
                                        <ErrorTitle>{translateStatus(props.data.tr_status)}:</ErrorTitle>
                                        <ErrorDescription>
                                            {
                                                messageError()
                                            }
                                        </ErrorDescription>                                        
                                    </AlertContainer>
                                </Row>
                            ) : null
                        }
                    
                        <Row>
                            <Jumbotron>
                                <JumbotronTitle>Venda</JumbotronTitle>
                                <div style={{display: "flex"}}>
                                    <div style={{width: "50%"}}>
                                        <InfoTitle>VALOR</InfoTitle>
                                        <Info>R$ {parseFloat(props.data.tr_amount).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Info>
                                    </div>
                                    <div style={{width: "50%"}}>
                                        <InfoTitle>Bandeira</InfoTitle>
                                        <Info>{props.data.mt_cardFlag}</Info>
                                    </div>
                                </div>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <div style={{width: "50%"}}>
                                        <InfoTitle>Tipo</InfoTitle>
                                        <Info>{translatePaymentType(props.data.tr_paymentType)}</Info>
                                    </div>
                                    <div style={{width: "50%"}}>
                                        <InfoTitle>Nº Parcelas</InfoTitle>
                                        <Info>{props.data.tr_numberInstalments === null ? "1" : props.data.tr_numberInstalments}</Info>
                                    </div>
                                </div>
                                <InfoTitle>Data de criação</InfoTitle>
                                <Info>{getTransactionDate()}</Info>
                            </Jumbotron>
                            
                            {
                                props.data.tr_paymentType === "credit" ? (
                                    <CreditCardContainer>
                                        <CreditCard 
                                            id={2} 
                                            firstNumbers={props.data.mt_first4Digits} 
                                            lastNumbers={props.data.mt_last4Digits} 
                                            name={props.data.mt_holderName  !== undefined ? props.data.mt_holderName.toUpperCase() : null}
                                            valid={`${props.data.mt_expirationMonth}/${props.data.mt_expirationYear}`}
                                        />
                                    </CreditCardContainer>
                                ) : null
                            }
                        </Row>

                        <Row>
                            <Jumbotron>
                                <JumbotronTitle>Vendedor</JumbotronTitle>
                                <InfoTitle>Nome</InfoTitle>
                                <Info>{seller?.businessName}</Info>
                                <InfoTitle>CNPJ</InfoTitle>
                                <Info>{seller?.cnpj}</Info>
                                <InfoTitle>E-mail</InfoTitle>
                                <Info>{seller?.email}</Info>
                                <InfoTitle>Telefone</InfoTitle>
                                <Info>{seller?.phone}</Info>
                            </Jumbotron>
                            <Jumbotron>
                                <JumbotronTitle>Comprador</JumbotronTitle>
                                <InfoTitle>Nome</InfoTitle>
                                <Info>{buyer.name}</Info>
                                <InfoTitle>CPF/CNPJ</InfoTitle>
                                <Info>{buyer.document}</Info>
                                <InfoTitle>Telefone</InfoTitle>
                                <Info>{buyer.phone}</Info>
                            </Jumbotron>
                        </Row>

                    </div>
                    {/* {
                        props.data.buyerIdAdquirente !== null && props.data.tr_status !== "succeeded" ? (
                            <Row>
                                <div className="w-100">
                                    <div className="d-flex justify-content-center">
                                        <SendMessageTitle>Enviar alerta ao cliente</SendMessageTitle>
                                    </div>
                                    <ButtonsShareContainer>
                                        <ButtonShare color={colors.greenDark} onClick={() => sendWhatsapp()}>
                                            <img src={whatsapp}/>
                                            <ButtonShareText>Enviar para whatsapp</ButtonShareText>
                                        </ButtonShare>
                                        <ButtonShare color={colors.textRed} onClick={() => sendEmail()}>
                                            <img src={mail}/>
                                            <ButtonShareText>Enviar por email</ButtonShareText>
                                        </ButtonShare>
                                    </ButtonsShareContainer>
                                </div>
                            </Row>
                        ) : null
                    } */}

                    <Row>
                        <ButtonsContainer>
                            <ButtonDownloadContainer>
                                <ButtonDownload onClick={() => downloadIMGOnClick()}>
                                    Baixar IMG
                                </ButtonDownload>
                            </ButtonDownloadContainer>

                            <ButtonDownloadContainer>
                                <ButtonDownload onClick={() => downloadPDFOnClick()}>
                                    Baixar PDF
                                </ButtonDownload>
                            </ButtonDownloadContainer>
                        </ButtonsContainer>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default ModalDetails